export default __webpack_public_path__ + "static/media/HomerOG.8c283afa.png";